<script lang="ts">
    import {Component, Vue} from 'vue-facing-decorator'

    @Component
    export class CruisePortsSearchMixin extends Vue {
        async searchCruisePorts(rq) {
            const defaults = {
                pattern: null,
                limit: 10,
            }
            //TODO Fix limit in API
            const rs = await this.$api.cruisePorts.get({...defaults, ...rq}, this.cancelTokenSource.token)

            return rs.map(port => {
                return Object.assign(port, {type: 'cruisePort', parentName: port.countryName})
            })
        }
    }

    export default CruisePortsSearchMixin
</script>
